<div class="row">
    <div class="col-lg-3 col-md-6 col-sm-12 grid-margin stretch-card macro-card">
        <div class="card macro">
            <div class="card-body no-padding"
                 [ngStyle]="{'background': 'linear-gradient(90deg, #FFE5DB '+percentage(diaryMacros.calories, userCalculations.calories)+', #fff 0%)'}">
                <div class="col-2 no-padding text-align-center d-flex flex-column justify-content-center">
                    <img
                            class="macro-image flipInX animated"
                            src="assets/images/macros/cal.svg"
                            alt="{{ 'calories' | localise }}"/>
                </div>
                <div class="col-6 no-padding d-flex flex-column justify-content-center macro-title">
                    {{ 'calories' | localise }}
                </div>
                <div class="col-4 text-right no-padding d-flex flex-column justify-content-center">
                    <span class="units">{{ round(this.userCalculations.calories) }} kcal</span>
                    <span class="percentage">{{ percentage(diaryMacros.calories, userCalculations.calories) }}</span>
                </div>
            </div>
        </div>
    </div>

    <div class="col-lg-3 col-md-6 col-sm-12 grid-margin stretch-card macro-card">
        <div class="card macro">
            <div class="card-body no-padding"
                 [ngStyle]="{'background': 'linear-gradient(90deg, #FFEDFD '+percentage(diaryMacros.protein, userCalculations.protein)+', #fff 0%)'}">
                <div class="col-2 no-padding text-align-center d-flex flex-column justify-content-center">
                    <img
                            class="macro-image flipInX animated"
                            src="assets/images/macros/protein.svg"
                            alt="{{ 'proteins' | localise }}"/>
                </div>
                <div class="col-6 no-padding d-flex flex-column justify-content-center macro-title">
                    {{ 'proteins' | localise }}
                </div>
                <div class="col-4 text-right no-padding d-flex flex-column justify-content-center">
                    <span class="units">{{ round(this.userCalculations.protein) }} {{ 'abbreviation_gram' | localise }}</span>
                    <span class="percentage">{{ percentage(diaryMacros.protein, userCalculations.protein) }}</span>
                </div>
            </div>
        </div>
    </div>

    <div class="col-lg-3 col-md-6 col-sm-12 grid-margin stretch-card macro-card">
        <div class="card macro">
            <div class="card-body no-padding"
                 [ngStyle]="{'background': 'linear-gradient(90deg, #FFF7C4 '+percentage(diaryMacros.carbs, userCalculations.carbs)+', #fff 0%)'}">
                <div class="col-2 no-padding text-align-center d-flex flex-column justify-content-center">
                    <img
                            class="macro-image flipInX animated"
                            src="assets/images/macros/carbs.svg"
                            alt="{{ 'carbs' | localise }}"/>
                </div>
                <div class="col-6 no-padding d-flex flex-column justify-content-center macro-title">
                    {{ 'carbs' | localise }}
                </div>
                <div class="col-4 text-right no-padding d-flex flex-column justify-content-center">
                    <span class="units">{{ round(this.userCalculations.carbs) }} {{ 'abbreviation_gram' | localise }}</span>
                    <span class="percentage">{{ percentage(diaryMacros.carbs, userCalculations.carbs) }}</span>
                </div>
            </div>
        </div>
    </div>

    <div class="col-lg-3 col-md-6 col-sm-12 grid-margin stretch-card macro-card">
        <div class="card macro">
            <div class="card-body no-padding"
                 [ngStyle]="{'background': 'linear-gradient(90deg, #CCFFDF '+percentage(diaryMacros.fat, userCalculations.fat)+', #fff 0%)'}">
                <div class="col-2 no-padding text-align-center d-flex flex-column justify-content-center">
                    <img
                            class="macro-image flipInX animated"
                            src="assets/images/macros/fats.svg"
                            alt="{{ 'fats' | localise }}"/>
                </div>
                <div class="col-6 no-padding d-flex flex-column justify-content-center macro-title">
                    {{ 'fats' | localise }}
                </div>
                <div class="col-4 text-right no-padding d-flex flex-column justify-content-center">
                    <span class="units">{{ round(this.userCalculations.fat) }} {{ 'abbreviation_gram' | localise }}</span>
                    <span class="percentage">{{ percentage(diaryMacros.fat, userCalculations.fat) }}</span>
                </div>
            </div>
        </div>
    </div>


</div>
